import { supabase } from '../config/supabaseClient.js';
import { operadorAtual } from './operador.js';
import { sessao } from './auth.js';

const CHAVE = 'permissoes_perfis';

// Seções configuráveis (módulos). Usuários e Configurações são SEMPRE só do GESTOR.
export const SECOES = [
  { grupo: 'Acessos', chave: 'chaves', rotulo: 'Chaves (movimentação)' },
  { grupo: 'Acessos', chave: 'cracha', rotulo: 'Crachá' },
  { grupo: 'Acessos', chave: 'visita_adm', rotulo: 'Visita administrativa' },
  { grupo: 'Acessos', chave: 'visita_assist', rotulo: 'Visita assistencial' },
  { grupo: 'Gestão', chave: 'kpis', rotulo: 'KPIs' },
  { grupo: 'Gestão', chave: 'pesquisa', rotulo: 'Pesquisa / Histórico' },
  { grupo: 'Gestão', chave: 'relatorios', rotulo: 'Relatórios' },
  { grupo: 'Cadastros', chave: 'cad_chaves', rotulo: 'Cadastro de chaves' },
  { grupo: 'Cadastros', chave: 'cad_colaboradores', rotulo: 'Colaboradores' },
  { grupo: 'Cadastros', chave: 'cad_empregadores', rotulo: 'Empregadores' },
  { grupo: 'Cadastros', chave: 'cad_setores', rotulo: 'Setores' },
  { grupo: 'Visitas', chave: 'cad_visita_motivo', rotulo: 'Motivos de visita' },
  { grupo: 'Visitas', chave: 'cad_visita_empresa', rotulo: 'Empresas/órgãos representados' },
];

export const PERFIS = [
  { chave: 'SUPERVISOR', rotulo: 'Supervisor' },
  { chave: 'RECEP_ADM', rotulo: 'Recepcionista administrativo' },
  { chave: 'RECEP_ASSIST', rotulo: 'Recepcionista assistencial' },
];

const todas = (v) => Object.fromEntries(SECOES.map((s) => [s.chave, v]));
const PADRAO = {
  SUPERVISOR: todas(true),
  RECEP_ADM: { ...todas(false), chaves: true, cracha: true, visita_adm: true },
  RECEP_ASSIST: { ...todas(false), visita_assist: true },
};
let cfg = JSON.parse(JSON.stringify(PADRAO));

export function permissoesPerfis() { return JSON.parse(JSON.stringify(cfg)); }

export async function carregarPermissoes() {
  try {
    const { data } = await supabase.from('configuracoes').select('valor').eq('chave', CHAVE).maybeSingle();
    const v = (data && data.valor) ? data.valor : {};
    cfg = {
      SUPERVISOR: { ...PADRAO.SUPERVISOR, ...(v.SUPERVISOR || {}) },
      RECEP_ADM: { ...PADRAO.RECEP_ADM, ...(v.RECEP_ADM || {}) },
      RECEP_ASSIST: { ...PADRAO.RECEP_ASSIST, ...(v.RECEP_ASSIST || {}) },
    };
  } catch { cfg = JSON.parse(JSON.stringify(PADRAO)); }
  return permissoesPerfis();
}

export async function salvarPermissoes(novo) {
  const { error } = await supabase.from('configuracoes').upsert({ chave: CHAVE, valor: novo, updated_at: new Date().toISOString() }, { onConflict: 'chave' });
  if (!error) cfg = JSON.parse(JSON.stringify(novo));
  return !error;
}

/** Perfil que vale agora = o do OPERADOR ativo (ou, na falta, o do login). */
export function perfilAtivo() { return operadorAtual.perfil || sessao.usuario?.perfil || null; }
export function ehGestorAtivo() { return perfilAtivo() === 'GESTOR'; }
export function ehGestaoAtivo() { const p = perfilAtivo(); return p === 'GESTOR' || p === 'SUPERVISOR'; }

/** O perfil ativo pode acessar a seção? (GESTOR pode tudo.) */
export function podeAcessar(secao) {
  const p = perfilAtivo();
  if (p === 'GESTOR') return true;
  const ov = operadorAtual.permissoes;
  if (ov && Object.prototype.hasOwnProperty.call(ov, secao)) return !!ov[secao];
  return !!(cfg[p] && cfg[p][secao]);
}

const ROTAS_SECAO = [
  ['/movimentacao', 'chaves'],
  ['/cracha', 'cracha'],
  ['/visita-administrativa', 'visita_adm'],
  ['/dashboard', 'kpis'],
  ['/pesquisa', 'pesquisa'],
  ['/chaves', 'cad_chaves'],
  ['/colaboradores', 'cad_colaboradores'],
  ['/empregadores', 'cad_empregadores'],
  ['/setores', 'cad_setores'],
  ['/visita-motivos', 'cad_visita_motivo'],
  ['/visita-empresas', 'cad_visita_empresa'],
];
/** Seção (módulo) associada a uma rota, ou null. */
export function secaoDaRota(caminho) { const e = ROTAS_SECAO.find(([c]) => c === caminho); return e ? e[1] : null; }
/** Primeira rota que o perfil ativo pode abrir (ou null se nenhuma). */
export function rotaInicial() {
  if (ehGestorAtivo()) return '/dashboard';   // gestor abre nos KPIs; recepcao cai em Chaves (primeira rota acessivel)
  for (const [c, s] of ROTAS_SECAO) if (podeAcessar(s)) return c;
  return null;
}

